import { OrganizationOnboarding } from '@/components/OrganizationOnboarding';
import { createFileRoute } from '@tanstack/react-router';
import type { AppContext } from '../main';

export const Route = createFileRoute('/')<AppContext>({
  component: App,
  loader: () => ({
    crumb: 'Home',
  }),
});

function App() {
  return (
    <div className="max-w-12xl mx-auto w-full">
      <OrganizationOnboarding />
    </div>
  );
}
